import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { Row, Col, Select } from 'antd';

// import 'antd/lib/popover/style/css';
// import 'antd/lib/icon/style/css';
// import 'antd/dist/antd.css';
import './styles.css';



import logo from '../../Images/newlogo.png';
import MenuMarkup from '../MenuMarkup/Index';
import { useLocation, useNavigate } from 'react-router-dom';
// import { FormattedMessage } from 'react-intl';
// import messages from './message';

const ResponsiveNav = ({
    mobileBreakPoint,  
    applyViewportChange}) => {
    const [viewportWidth, setViewportWidth] = useState(0);

    // Save the viewport width, similar to componentDidMount and componentWillUnmount
    const saveViewportDimensions = useCallback(
        throttle(() => {
            setViewportWidth(window.innerWidth);
        }, applyViewportChange),
        [applyViewportChange]
    );

    useLocation();

    const navigate = useNavigate();

    useEffect(() => {
        saveViewportDimensions(); // Set initial viewport width
        window.addEventListener('resize', saveViewportDimensions); // Attach resize event listener
        return () => {
            window.removeEventListener('resize', saveViewportDimensions); // Cleanup
        };
    }, [saveViewportDimensions]);


    const handleLanguageChange = (value) => {
        localStorage.setItem('INTL', value);
        navigate(0);
        // location.reload();
    };

    // Render different layouts based on viewport width
    if (viewportWidth > mobileBreakPoint) {
        return (
            <Row>
                <Col span={16} >
                    <a href="/"><img style={{ width: '178px', height: '37px', margin: '16px 24px 16px 0', float: 'left', paddingLeft: '3%' }} src={logo} alt="nill" /></a>
                </Col>
                <Col span={4} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                    <Select value={localStorage.getItem('INTL') ? localStorage.getItem('INTL') : 'en'} style={{ width: 150 }}
                        onChange={handleLanguageChange}
                    >
                        <Select.Option value="en">English</Select.Option>
                        <Select.Option value="ma">മലയാളം</Select.Option>
                        <Select.Option value="hin">हिन्दी</Select.Option>

                    </Select>
                </Col>
                <Col span={4} style={{ textAlign: 'right', paddingRight: '3%' }}>

                    <MenuMarkup />
                </Col>
            </Row>
        );
    }

    return (
        <>
            <Row>
                <Col span={16} >
                    <a href="/"><img style={{ width: '178px', height: '37px', margin: '16px 24px 16px 0', float: 'left', paddingLeft: '3%' }} src={logo} alt="nill" /></a>
                </Col>
                <Col span={4} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                    <Select value={localStorage.getItem('INTL') ? localStorage.getItem('INTL') : 'en'} style={{ width: 150 }}
                        onChange={handleLanguageChange}
                    >
                        <Select.Option value="en">English</Select.Option>
                        <Select.Option value="ma">മലയാളം</Select.Option>
                        <Select.Option value="hin">हिन्दी</Select.Option>

                    </Select>
                </Col>
                <Col span={4} style={{ textAlign: 'right', paddingRight: '3%' }}>

                    <MenuMarkup />
                </Col>
            </Row>
            {/* <div style={{ minHeight: '820vh',  background: 'linear-gradient(129.32deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4' }}> */}

        </>
    );
};

ResponsiveNav.propTypes = {
    mobileBreakPoint: PropTypes.number,
    applyViewportChange: PropTypes.number,
    activeLinkKey: PropTypes.string,
    placement: PropTypes.string,
    menuMarkup: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object,
    ]).isRequired,
};

ResponsiveNav.defaultProps = {
    mobileBreakPoint: 772,
    applyViewportChange: 250,
    placement: 'bottom',
};

export default ResponsiveNav;
